import { render } from "./ModalDetails.vue?vue&type=template&id=41e96130&scoped=true&ts=true"
import script from "./ModalDetails.vue?vue&type=script&lang=ts"
export * from "./ModalDetails.vue?vue&type=script&lang=ts"

import "./ModalDetails.vue?vue&type=style&index=0&id=41e96130&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e96130"]])

export default __exports__